import { render, staticRenderFns } from "./BungaGadai.vue?vue&type=template&id=5de8a995&"
import script from "./BungaGadai.vue?vue&type=script&lang=js&"
export * from "./BungaGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports